import {
  memo,
  useCallback,
  useMemo,
} from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import useStyles from './styles'
import type { Progress, Props } from './types'

const ProgressBar = memo<Props>((
  {
    currentTime,
    duration,
    setCurrentTime,
  },
) => {
  const { classes } = useStyles()
  const handleClick = useCallback((event: any) => {
    const progress: Progress = (event.pageX - event.currentTarget.offsetLeft) / event.currentTarget.offsetWidth
    setCurrentTime((duration ?? 0) * progress)
  }, [duration, setCurrentTime])

  return (
    <LinearProgress
      classes={useMemo(() => ({
        root: classes.linearProgress,
      }), [classes])}
      onClick={handleClick}
      value={currentTime && duration ? currentTime / duration * 100 : 0}
      valueBuffer={1}
      variant='determinate'
    />
  )
})

ProgressBar.displayName = 'ProgressBar'

export default ProgressBar
